import { cn } from '../cn'
import { Skeleton } from './skeleton'

interface StatCardSkeletonProps {
  className?: string
  align?: 'left' | 'center'
  showSublabel?: boolean
  /**
   * `controls` — matches framework/controls stat cards (border, 10px label, 22px value).
   */
  variant?: 'default' | 'controls'
}

export function StatCardSkeleton({
  className,
  align = 'left',
  showSublabel = false,
  variant = 'default',
}: StatCardSkeletonProps) {
  const centered = align === 'center'
  const isControls = variant === 'controls'

  return (
    <div
      className={cn(
        'rounded-sm bg-card px-5 py-4',
        isControls && 'border border-border-surface',
        centered && 'text-center',
        className
      )}
    >
      <Skeleton
        className={cn(
          'rounded-sm',
          isControls ? 'h-[14px] w-24 max-w-[75%]' : 'h-3 w-24',
          centered && 'mx-auto'
        )}
      />
      <Skeleton
        className={cn(
          'rounded-sm',
          isControls ? 'mt-2 h-7 w-9' : 'mt-3 h-6 w-8',
          centered && 'mx-auto'
        )}
      />
      {showSublabel && (
        <Skeleton
          className={cn('mt-2 h-3 w-20 rounded-sm', centered && 'mx-auto')}
        />
      )}
    </div>
  )
}
